/* eslint-disable prettier/prettier */
import { memo, useContext } from 'react';

import Button from '@/components/old/Button';

import ModalContext from '../../../contexts/Modal/ModalContext';
import { ModalBorderTopColor, ModalConstructor } from '../ModalConstructor';

import './DocumentAddCheckAlert.scss';

export const DocumentAddCheckAlert = memo(function DocumentAddCheckAlert() {
  const { toggleModal } = useContext(ModalContext);

  return (
    <ModalConstructor modalBorderTopColor={ModalBorderTopColor.yellow}>
      <div className="birthday-alert">
        <div className="birthday-alert__title">Цей документ вже доданий</div>

        <div className="birthday-alert__buttons-box">
          <Button isBorder={true} isMaxWidth={true} onClick={() => toggleModal(false)}>
            Закрити
          </Button>
        </div>
      </div>
    </ModalConstructor>
  );
});
